import { LO_APPLICATION_SUBMITTED_STORAGE_PREFIX } from '@/domain/job-application';
import { JobPostingVisibleJobFragment, JobUserXingApplicationStatus } from '@/graphql/generated';
import { getKey } from '@/helpers/storage';
import { useLoginStates } from '@/hooks';

export const useAppliedConfirmation = (job: JobPostingVisibleJobFragment): string => {
  const { isLoggedIn } = useLoginStates();
  const application = job.userInteractions?.application;

  const loggedInSubmissionDate =
    application?.status &&
    application.status !== JobUserXingApplicationStatus.Error &&
    application.status !== JobUserXingApplicationStatus.Undelivered
      ? application?.createdAt
      : '';

  const loggedOutSubmissionDate =
    getKey<{ submittedAt?: string }>(`${LO_APPLICATION_SUBMITTED_STORAGE_PREFIX}:${job.slug}`, {}).submittedAt || '';

  return isLoggedIn ? loggedInSubmissionDate : loggedOutSubmissionDate;
};
